export default {
  title: {
    en: 'Last-minute impulse buys',
  },
  text: {
    en: `
      Want to treat yourself to something extra? Add<br class="mobile" /> any of <br class="exceptMobile" />
      pre-selected items to your order for an <br class="mobile" />extra <span class="brandColor">$10</span> per product,<br class="exceptMobile" />
      and we’ll include them in <br class="mobile" />your upcoming shipment.
    `,
  },
  buttonTitle: {
    en: 'Add to order',
  },
}
